/**
 * The tabs of the own account (mockup v3 P1, `/cuenta/:tab`), as data: the router, the user menu,
 * the Ctrl+K palette and the breadcrumb read the same four, in this order. Contraseña and
 * Verificación en dos pasos are reached from the account page itself, so only the breadcrumb names
 * them too.
 */

import type { IconName } from "../../shared/design-system/icons";
import type { TranslationKey } from "../../shared/i18n";

export const ACCOUNT_PATH = "/cuenta";

export interface AccountTab {
  /** The `:tab` segment, in Spanish because it is part of the address the person reads. */
  readonly segment: string;
  readonly labelKey: Extract<TranslationKey, `app.account.${string}` | `account.tabs.${string}`>;
  readonly icon: IconName;
}

export const ACCOUNT_TABS: readonly AccountTab[] = [
  { segment: "perfil", labelKey: "app.account.profile", icon: "user" },
  { segment: "sesiones", labelKey: "app.account.sessions", icon: "monitor" },
  { segment: "accesos", labelKey: "app.account.accessLog", icon: "history" },
  { segment: "datos", labelKey: "app.account.data", icon: "download" },
];

/** The sections outside the user menu and the palette, which the breadcrumb still names. */
const ACCOUNT_PAGE_ONLY_TABS: readonly AccountTab[] = [
  { segment: "contrasena", labelKey: "account.tabs.password", icon: "lock" },
  { segment: "2fa", labelKey: "account.tabs.totp", icon: "phone" },
];

/** The address of a tab. */
export function accountHref(tab: AccountTab): string {
  return `${ACCOUNT_PATH}/${tab.segment}`;
}

/** The section an address belongs to, or `undefined` when it is not one of the six. */
export function accountTabOf(pathname: string): AccountTab | undefined {
  return [...ACCOUNT_TABS, ...ACCOUNT_PAGE_ONLY_TABS].find((tab) => pathname === accountHref(tab));
}
